// extracted by mini-css-extract-plugin
export var a = "footer-module--a--4o3Rv";
export var footer = "footer-module--footer--ov5Kw";
export var logo = "footer-module--logo--mrnDn";